var _g, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle3, _circle4, _path1, _path10, _path11, _circle5, _circle6, _path12, _circle7, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBat25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 126,
    viewBox: "0 0 191 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_50316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3983 4.09931C48.3573 1.47557 51.8982 0.599273 54.3983 0.0993072C56.8984 -0.400659 63.8982 1.09925 65.8983 2.09931C67.8984 3.09936 69.3975 10.0994 74.3975 11.5994C79.3975 13.0994 169.897 10.5994 172.897 10.5994C175.898 10.5994 180.397 14.7799 180.397 18.0994V28.5994C180.397 32.5994 180.397 35.5993 177.397 37.0994C172.897 39.3494 173.049 40.1721 171.397 42.0994C169.745 44.0267 169.796 44.6335 170.398 47.0993C171.299 50.7822 173.861 52.2816 176.397 55.0994C180.898 60.0994 182.063 61.1722 183.897 66.0994C186.162 72.1823 186.875 76.1086 186.897 82.5994C186.921 89.284 185.831 92.5923 182.898 98.5994C179.562 105.434 175.067 109.444 168.398 113.099C163.849 115.593 160.586 115.599 155.397 115.599C147.397 115.599 143.932 115.18 136.398 113.099C131.278 111.685 128.555 110.371 123.398 109.099C111.397 106.139 79.0327 107.493 72.3975 108.599C69.3975 109.099 61.3975 112.109 56.8975 114.099C51.5403 116.469 46.3975 117.599 40.3975 117.599C34.4684 117.599 29.3975 116.099 26.8975 115.099C24.3975 114.099 17.8975 110.099 16.3975 108.599C14.8975 107.099 9.46579 100.63 7.39833 94.5993C5.21209 88.2221 3.9835 84.328 4.39833 77.5993C4.85428 70.2037 6.10388 65.6376 10.3983 59.5993C13.8477 54.7493 16.7226 52.5374 21.8983 49.5993C28.8998 45.6249 37.8975 46.5994 41.8983 44.5993C45.9906 42.5536 47.4401 39.7342 49.3983 35.5993C51.6795 30.7826 53.1557 24.833 51.3983 22.0993L46.8983 15.0993C43.6244 10.7823 42.4393 6.72304 45.3983 4.09931Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.308 27.1144C129.904 29.537 125.036 30.9656 120.012 28.7295C110.785 27.008 103.861 24.8936 103.659 23.8842C103.457 22.8747 106.284 22.6729 106.284 22.6729H111.331L120.618 22.8747L126.472 22.6729C129.381 23.4717 130.712 24.6917 130.308 27.1144Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6809 82.8356L44.7092 79.8073L53.1885 56.9941L48.3432 55.7828L49.7564 50.5337C49.7564 50.5337 50.9677 46.2943 50.5639 45.4866C50.1602 44.6789 46.6284 50.6849 44.7092 58.0035L46.93 59.6186L39.864 81.2204L41.6809 82.8356Z",
    fill: "#ECEBEB",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.024 43.0635L57.749 40.6358L55.4089 39.9834L54.8032 41.0446L52.5825 42.8616L49.958 52.5521L51.9768 53.5616L53.9957 46.6974L55.4089 46.0918L57.024 43.0635Z",
    fill: "#797979",
    stroke: "#797979"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 44.9111 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 71.9639 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9585 57.1959L33.6057 105.043M68.5321 88.8921L15.234 72.5393M25.934 59.6185L59.2453 103.832M65.7057 68.5015L16.8491 93.5355M36.8359 55.3789L47.1321 106.86M59.6491 60.0223L23.5114 102.015M14.8302 83.2393L69.9453 77.9902",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.744 53.5614L120.618 56.3878L121.627 52.552C121.985 51.6625 121.984 51.2105 121.425 50.5331L118.599 49.3218C116.638 49.0574 115.636 49.1813 113.955 49.7255L112.744 53.5614Z",
    fill: "black",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0324 25.3035L61.9896 25.9559C61.9896 25.9559 64.4451 22.4225 64.0899 19.8463C63.9671 18.9558 63.7963 18.4685 63.4842 17.6255C62.2043 14.1687 54.3255 12.8348 57.2257 10.5595C57.5874 10.2757 57.9508 10.3151 58.2351 9.95384C59.035 8.93782 57.024 7.32942 56.2163 6.72376C55.4087 6.1181 53.3971 4.43606 52.9861 5.71422C52.7341 6.49783 53.8756 6.96044 53.5918 7.73309C53.4558 8.10312 53.1896 8.20301 52.9861 8.54064C52.2434 9.77287 51.6541 10.9327 52.3804 12.1746C52.8994 13.0619 53.7461 13.0172 54.6012 13.5878C56.0573 14.5595 56.9854 14.9865 58.2351 16.2123C59.6877 17.6371 60.9402 18.4431 61.2634 20.452C61.5922 22.4952 60.0324 25.3035 60.0324 25.3035Z",
    fill: "#797979",
    stroke: "#797979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.937 46.8995L114.158 47.5052L119.81 28.7297L117.388 28.3259L111.937 46.8995Z",
    fill: "#ECEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.331 46.8995L114.561 47.707L112.341 53.7636L120.618 56.5901L120.214 58.2052L153.122 77.7882L155.141 80.8165L152.112 80.6146L119.407 60.8297L111.533 86.2674L114.158 86.8731L114.965 84.6523L150.699 81.2202V84.0466L118.195 87.4787L117.186 87.8825L116.58 95.3523L102.246 91.9202L101.237 88.8919L81.6539 71.5297L70.5501 55.3787L60.6576 38.2184L59.4463 37.6127L58.4369 40.641L55.0048 39.2278L59.0425 25.4995L62.6765 26.7108V28.7297C72.0728 49.3692 77.1468 58.0072 85.6916 66.0787C92.905 69.1193 97.0395 70.0375 104.669 69.5108L111.331 46.8995Z",
    fill: "#ECEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.937 46.8995L114.158 47.5052L119.81 28.7297L117.388 28.3259L111.937 46.8995Z",
    stroke: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.331 46.8995L114.561 47.707L112.341 53.7636L120.618 56.5901L120.214 58.2052L153.122 77.7882L155.141 80.8165L152.112 80.6146L119.407 60.8297L111.533 86.2674L114.158 86.8731L114.965 84.6523L150.699 81.2202V84.0466L118.195 87.4787L117.186 87.8825L116.58 95.3523L102.246 91.9202L101.237 88.8919L81.6539 71.5297L70.5501 55.3787L60.6576 38.2184L59.4463 37.6127L58.4369 40.641L55.0048 39.2278L59.0425 25.4995L62.6765 26.7108V28.7297C72.0728 49.3692 77.1468 58.0072 85.6916 66.0787C92.905 69.1193 97.0395 70.0375 104.669 69.5108L111.331 46.8995Z",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 181.386 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 154.333 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M159.38 57.1959L143.028 105.043M177.954 88.8921L124.656 72.5393M135.356 59.6185L168.667 103.832M175.128 68.5015L126.271 93.5355M146.258 55.3789L156.554 106.86M169.071 60.0223L132.933 102.015M124.252 83.2393L179.367 77.9902",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.035 79.2011L151.507 78.3936L151.709 83.2388L100.632 93.9388",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.274 81.2201L103.457 84.6522L104.265 86.0654L108.303 86.873L107.899 88.69L104.063 87.8824L103.054 89.2956L103.256 92.9296H101.439V89.6994L99.0159 88.8918L96.1895 90.305L95.5839 88.69L98.4103 87.2767L98.6122 85.6617L95.9876 83.0371L96.9971 81.6239L100.025 84.2484L101.64 83.8447L103.457 80.4126L105.274 81.2201Z",
    fill: "black",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.27736,
    cy: 8.27736,
    r: 6.77736,
    transform: "matrix(-1 0 0 1 109.918 78.3936)",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 3.23019,
    transform: "matrix(-1 0 0 1 104.669 83.6426)",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5841 101.61L101.641 89.0935L102.448 86.6708L100.631 85.8633L98.8143 88.6897L92.9596 101.61H90.335V103.629L91.3445 105.043H97.1992L98.4105 104.033V101.61H95.5841Z",
    fill: "black",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81698,
    cy: 1.81698,
    r: 1.81698,
    transform: "matrix(-1 0 0 1 55.8135 4.09961)",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.44 21.3062H142.067V33.174H138.44V21.3062Z",
    fill: "#DE0000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.625 15.75C137.133 15.75 135.702 16.369 134.648 17.4707C133.593 18.5725 133 20.0669 133 21.625V33.375C133 34.9331 133.593 36.4275 134.648 37.5293C135.702 38.631 137.133 39.25 138.625 39.25H166.75C168.242 39.25 169.673 38.631 170.727 37.5293C171.782 36.4275 172.375 34.9331 172.375 33.375V21.625C172.375 20.0669 171.782 18.5725 170.727 17.4707C169.673 16.369 168.242 15.75 166.75 15.75H138.625ZM166.75 18.6875C167.496 18.6875 168.211 18.997 168.739 19.5479C169.266 20.0988 169.562 20.8459 169.562 21.625V33.375C169.562 34.1541 169.266 34.9012 168.739 35.4521C168.211 36.003 167.496 36.3125 166.75 36.3125H138.625C137.879 36.3125 137.164 36.003 136.636 35.4521C136.109 34.9012 135.812 34.1541 135.812 33.375V21.625C135.812 20.8459 136.109 20.0988 136.636 19.5479C137.164 18.997 137.879 18.6875 138.625 18.6875H166.75ZM178 27.5C178 28.6686 177.556 29.7894 176.764 30.6157C175.973 31.442 174.9 31.9063 173.781 31.9063V23.0938C174.9 23.0938 175.973 23.558 176.764 24.3843C177.556 25.2106 178 26.3314 178 27.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_50316",
    x: 0.318359,
    y: 0,
    width: 190.579,
    height: 125.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_50316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_50316",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat25);
export default __webpack_public_path__ + "static/media/bat_25.7ec28540af3a5cf365d3523670f9b261.svg";
export { ForwardRef as ReactComponent };